import { render, staticRenderFns } from "./DettaglioAttivita.vue?vue&type=template&id=ca70aab0&scoped=true&"
import script from "./DettaglioAttivita.vue?vue&type=script&lang=js&"
export * from "./DettaglioAttivita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca70aab0",
  null
  
)

export default component.exports